<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <!-- Page title -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <h2 class="page-title">
                Add Missing Links for {{client.firstName}} {{client.lastName}}
              </h2>
            </div>
          </div>
        </div>
        
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card" v-if="missingLinks">
              <paged-api-table
                v-bind:columns="linkColumns"
                module="ClientPage"
                module-id="id"
                @click="linkClicked"
                @itemUpdated="onLinkUpdated"
                v-bind:custom-data-source="customDataSource"
                v-bind:per-page="linkPerPage"
                v-bind:refresh-for-id="lastRefreshTime">
                </paged-api-table>
                
                <button class="btn btn-primary" @click="addLinks">Add Selected Missing Links</button>
            </div>
            
            <div class="card" v-if="!missingLinks">
              <div style="text-align:center; padding: 30px;"><img src="../assets/ajax-loader.gif" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <add-date dlg-id="dlg-add-date" @selected="dateChanged"></add-date>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import AddDate from "./AddDate.vue";
  import PagedApiTable from "./PagedApiTable.vue";
  import WebLLCRESTApi from "../api/api";
  import UUID from "../util/uuid";
  import $ from "jquery";
  
  import imgPositive from "../assets/plus.svg";
  import imgNeutral from "../assets/equals.svg";
  import imgNegative from "../assets/minus.svg";
  
  export default {
    created() {
      this.clientApi = new WebLLCRESTApi("Clients", this.$router);
      this.searchResultApi = new WebLLCRESTApi("Search-Results", this.$router);
      
      (async () => {
        this.searchResults = await this.getAllPages(this.$route.params.id);
        
        if(this.searchResults.length > 0) {
          this.client = await this.clientApi.getData(this.searchResults[0].clientId);
          
          this.missingLinks = (await (await this.searchResultApi.remoteMethod(this.$route.params.id + "/missinglinks")).json())
            .map((link) => {
              return {
                linkType: "neutral",
                source: "std",
                url: link.url
              }
            });
        }
      })();
    },
    
    data() {
      return {
        client: {},
        
        missingLinks: null,
        selLink: null,
        
        customDataSource: this.getTemporaryDataSource(),
        
        linkColumns: [
          {
            key: "linkType",
            text: "Positive/Negative",
            type: "ImageOptions",
            options: [
              { key: "positive", value: "Positive", img: imgPositive, class: "green-option" },
              { key: "negative", value: "Negative", img: imgNegative, class: "red-option" },
              { key: "neutral", value: "Neutral", img: imgNeutral, class: "orange-option" }
            ],
            editable: true,
            sort: true
          },
          { key: "source", "text": "Source", type: "Dropdown", options: [ { key: "std", value: "Standard Link" }, { key: "article", value: "Article (Positive only)" }, { key: "social", value: "Social Site (Positive only)" }] },
          { key: "createdAt", "text": "Created At", type: "Date" },
          { key: "setDate", "text": "Set Article Date", type: "Event" },
          { key: "url", "text": "URL", type: "URL" }
        ],
        
        linkPerPage: 100,
        
        lastRefreshTime: "0"
      };
    },
    
    methods: {
      getTemporaryDataSource() {       
        return {
          getData: (refreshPageCount, page, perPage) => {
            const data = this.missingLinks
              .filter((item, index) => index >= (page * perPage) && index < ((page + 1) * perPage) );
            
            return {
              data: data,
              totalCount: data.length
            };
          }
        };
      },
      
      async linkClicked(data) {
        const selLink = data.item.item;
        
        if(data.col.text == "Set Article Date") {
          this.selLink = selLink;
          $('#dlg-add-date').modal('toggle');
        }
      },
      
      onLinkUpdated(data) {
        for(const missingLink of this.missingLinks) {
          if(missingLink.url == data.item.item.url) {
            if(data.col.key == "linkType") {
              missingLink.linkType = data.newValue;
            }
            else {
              missingLink.source = data.newValue;
            }
          }
        }
      },
      
      dateChanged(newDate) {
        if(newDate) {
          this.selLink.createdAt = newDate;
        }
        else {
          this.selLink.createdAt = null;
        }
        
        this.lastRefreshTime = Date.now().toString();
      },
      
      async getAllPages(id) {
        return (await (await this.searchResultApi.remoteMethod(this.$route.params.id + "/group")).json());
      },
      
      async addLinks() {
        // move back to the loading bar
        const missingLinks = this.missingLinks;
        this.missingLinks = null;
        
        // add the links
        for(const missingLink of missingLinks) {
          if(missingLink.source == "article") {
            const api = new WebLLCRESTApi("Client-Pages", this.$router);
            await api.addData({
              category: "article",
              linkType: "positive",
              createdAt: this.getUTCDate(missingLink.createdAt).toISOString(),
              url: missingLink.url,
              clientId: this.client.id
            });
          }
          else if(missingLink.source == "social") {
            const api = new WebLLCRESTApi("Client-Pages", this.$router);
            await api.addData({
              category: "socialprofile",
              linkType: "positive",
              createdAt: this.getUTCDate(missingLink.createdAt).toISOString(),
              url: missingLink.url,
              clientId: this.client.id
            });
          }
          else {
            const api = new WebLLCRESTApi("Client-Pages", this.$router);
            await api.addData({
              id: UUID.genUuidV4(),
              linkType: missingLink.linkType,
              url: missingLink.url,
              clientId: this.client.id
            });
          }
        }
        
        //  set the search results to the noimage stage ready for screenshotting to take place immediately
        for(const searchResult of this.searchResults) {
          await this.searchResultApi.updateData(searchResult.id, {
              status: "noimage"
            });
        }
        
        // move back to the client
        this.$router.push("/client/" + this.client.id);
      },
      
      getUTCDate(dt) {
        if(!dt) {
          return new Date();
        }
        
        const date = new Date(dt);
        const utcDate = new Date();
        
        utcDate.setUTCFullYear(date.getFullYear());
        utcDate.setUTCMonth(date.getMonth());
        utcDate.setUTCDate(date.getDate());
        utcDate.setUTCHours(0);
        utcDate.setUTCMinutes(0);
        utcDate.setUTCSeconds(0);
        utcDate.setUTCMilliseconds(0);
        
        return utcDate;
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter,
      AddDate,
      PagedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AddMissingLinks.vue